import * as React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import * as actions from '../../../../../redux/projects/actions.projects';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import AutoComplete from '../../../../components/AutoComplete/AutoComplete';

type SearchLocationProps = {
    addLocation: (locstion) => void;
} & PropsFromRedux;

class SearchLocation extends React.Component<SearchLocationProps> {

    onSearch = ({ query }) => {
        const { searchLocationsForCohort } = this.props;
        return searchLocationsForCohort({ query }) as Promise<any[]>;

    }

    selectLocation = (location) => {
        const { addLocation } = this.props;
        this.setState({ showLocations: false, query: '', selectedLocationIndex: -1 });
        addLocation(location);
    }

    render() {
        return <AutoComplete
            minQueryLength={2}
            onSearch={this.onSearch}
            onSelect={this.selectLocation}
            placeholder="Country, City, State, Region.."
        />;
    }
}

function mapStateToProps({ projectsInfo }) {
    return {
        cohorts: projectsInfo.currentProject.cohorts,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        searchLocationsForCohort: (param) => asyncDispatch(actions.searchLocationsForCohort, dispatch, param),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connect(mapStateToProps, mapDispatchToProps)(SearchLocation);